
export const PAGE_NAME = "Jest tu jakiś cwaniak?";

export const ScreenSize = {
    lg: "992px",
    md: "768px"
}